import React from "react";
import { Typography } from "@material-ui/core";
import { getTestReportGroupings } from "../../../services/api/testReports.api";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import { DateDisplay } from "../../DateDisplay";
import { Fetcher } from "../../Fetcher";
import { pascalToTitleCase } from "../../../utils";
import colors from "../../../constants/colors";
import { TestReportGrouping } from "../../../models/TestReport";

export interface TestReportPickerProps {
	// used to notify a parent component when a selection is made
	onReportSelect: (reportName: string) => void;
}

const styles = {
	title: {
		marginBottom: 8,
	},
	treeWrapper: {
		height: 698,
		overflow: "auto",
	},
	treeItemLabel: {
		padding: "6px 2px",
		fontSize: 16,
	},
	treeItemLabelTitle: {
		display: "block",
		fontSize: 16,
	},
	treeItemLabelSubtitle: {
		display: "block",
		fontSize: 11,
		color: colors.gray600,
	},
};

const renderTreeView = (groupings: TestReportGrouping, { onReportSelect }: TestReportPickerProps) => (
	<div style={styles.treeWrapper}>
		<TreeView defaultCollapseIcon={<ExpandMoreIcon />} defaultExpandIcon={<ChevronRightIcon />}>
			{Object.keys(groupings).map((serviceKey) => {
				return (
					<TreeItem key={serviceKey} nodeId={serviceKey} label={<div style={styles.treeItemLabel}>{serviceKey}</div>}>
						{Object.keys(groupings[serviceKey]).map((envKey) => {
							return (
								<TreeItem
									key={envKey}
									nodeId={`${serviceKey}_${envKey}`}
									label={<div style={styles.treeItemLabel}>{envKey}</div>}
								>
									{Object.keys(groupings[serviceKey][envKey]).map((releaseKey) => {
										return (
											<TreeItem
												key={releaseKey}
												nodeId={`${serviceKey}_${envKey}_${releaseKey}`}
												label={<div style={styles.treeItemLabel}>{releaseKey}</div>}
											>
												{groupings[serviceKey][envKey][releaseKey].map(({ fullName, reportType, generatedOn }) => {
													return (
														<TreeItem
															onLabelClick={() => onReportSelect(fullName)}
															key={fullName}
															nodeId={`${serviceKey}_${envKey}_${releaseKey}_${fullName}`}
															label={
																<div style={styles.treeItemLabel}>
																	<span style={styles.treeItemLabelTitle}>{pascalToTitleCase(reportType)}</span>
																	<span style={styles.treeItemLabelSubtitle}>
																		<DateDisplay date={generatedOn} />
																	</span>
																</div>
															}
														></TreeItem>
													);
												})}
											</TreeItem>
										);
									})}
								</TreeItem>
							);
						})}
					</TreeItem>
				);
			})}
		</TreeView>
	</div>
);

// displays a tree view of test reports
export const TestReportPicker = (props: TestReportPickerProps) => {
	return (
		<div>
			<Typography style={styles.title} color="textSecondary">
				Choose a report to preview:
			</Typography>
			<Fetcher action={getTestReportGroupings()}>{(response) => renderTreeView(response.data, props)}</Fetcher>
		</div>
	);
};
